export const UPDATE_AUTO_PAY_REQUEST = 'UPDATE_AUTO_PAY_REQUEST';
export const UPDATE_AUTO_PAY_SUCCESS = 'UPDATE_AUTO_PAY_SUCCESS';
export const UPDATE_AUTO_PAY_FAILURE = 'UPDATE_AUTO_PAY_FAILURE';
